import { isValidElement } from "react";
export const isFallbackMap = (fallback) => {
    if (!fallback) {
        return false;
    }
    if (isValidElement(fallback)) {
        return false;
    }
    if (typeof fallback === "function") {
        return false;
    }
    return typeof fallback === "object";
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcmVzb3VyY2VzL1Jlc291cmNlTG9hZGluZ0Vycm9yQm91bmRhcnkvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFpQixjQUFjLEVBQWEsTUFBTSxPQUFPLENBQUM7QUF3QmpFLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxDQUMzQixRQUErQyxFQUNNLEVBQUU7SUFDdkQsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFDO1FBQ2QsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0lBRUQsSUFBSSxjQUFjLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQztRQUM3QixPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCxJQUFJLE9BQU8sUUFBUSxLQUFLLFVBQVUsRUFBRSxDQUFDO1FBQ25DLE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVELE9BQU8sT0FBTyxRQUFRLEtBQUssUUFBUSxDQUFDO0FBQ3RDLENBQUMsQ0FBQyJ9